const bread = document.querySelector("nav[data-ancestors]");
if (bread) {
	const ancestors = bread.dataset.ancestors.split(",");
	console.log("ancestors", ancestors);
	const menu_items = document.querySelectorAll('li[data-object-type="page"]');
	for (let i = 0; i < menu_items.length; i++) {
		console.log("item id", menu_items[i].dataset.objectId);
		if (ancestors.includes(menu_items[i].dataset.objectId.toString())) {
			menu_items[i].classList.add("current-menu-item");
			console.warn("found active!");
		}
	}
}
